(() => {
  const announce = (root, message) => {
    const live = root?.querySelector('[data-pz-live-status]');
    if (!live || !message) return;
    live.textContent = '';
    window.setTimeout(() => { live.textContent = message; }, 20);
  };

  const harden = (root) => {
    if (!root || root.dataset.pzProductionInitialized) return;
    root.dataset.pzProductionInitialized = 'true';

    const quantity = root.querySelector('[data-pz-quantity-input]');
    quantity?.addEventListener('change', () => {
      const min = Math.max(1, Number(quantity.min || 1));
      const value = Math.floor(Number(quantity.value || min));
      quantity.value = String(Math.max(min, Number.isFinite(value) ? value : min));
    });

    root.querySelectorAll('[data-pz-option-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const group = input.closest('[data-pz-option-group]');
        const name = group?.querySelector('legend, .pz-variant-picker__label')?.textContent?.trim() || 'Option';
        announce(root, `${name}: ${input.value} selected.`);
      });
    });

    root.querySelector('[data-pz-main-submit]')?.addEventListener('click', () => {
      const variant = root.querySelector('[data-pz-sticky-option-label]')?.textContent?.trim();
      announce(root, variant ? `Adding ${variant} to cart.` : 'Adding product to cart.');
    });

    root.querySelectorAll('[data-pz-thumb]').forEach((thumb, index) => {
      if (!thumb.getAttribute('aria-label')) thumb.setAttribute('aria-label', `View product media ${index + 1}`);
    });

    const stage = root.querySelector('[data-pz-stage]');
    if (stage && !stage.hasAttribute('tabindex')) stage.tabIndex = 0;

    root.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.decoding = 'async';
      img.addEventListener('error', () => img.closest('[data-pz-slide], [data-pz-look-card]')?.classList.add('has-media-error'), { once: true });
    });
  };

  const init = (scope = document) => scope.querySelectorAll('.pz-product-main[data-pz-production-ready="true"]').forEach(harden);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
